// // import App from './App';
import reportWebVitals from "./reportWebVitals";
import process from 'process'

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

import * as React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App";
// import * as serviceWorker from "./serviceWorker";
import { SnackbarProvider } from "notistack";
import { BrowserRouter } from "react-router-dom";
import { createBrowserHistory } from "history";

console.log = () => {};
ReactDOM.render(
  <React.Fragment>
    <SnackbarProvider maxSnack={1} preventDuplicate>
      <BrowserRouter history={createBrowserHistory}>
        <App />
      </BrowserRouter>
    </SnackbarProvider>
  </React.Fragment>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
